import StyleHelper from 'util/style'
import moduleStyle from './sidebar.module.scss'
export const style = StyleHelper(moduleStyle)
export default style
